// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__hGv69","buttons":"Footer_buttons__mTYJx"};